import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Footer, Navbar } from "./Components";
import { Home, NoPage} from "./Pages";


function App() {
  return (
    <div className="App scroll-smooth bg-black">

      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/*" element={<NoPage />} />
        </Routes>
        <Footer />
        
      </BrowserRouter>

    </div>
  );
}

export default App;
